export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
  REDIRECT_ON_OPTIONS: {"ALL":"all","ROOT":"root","NO_PREFIX":"no prefix"},
}
export const nuxtOptions = {
  isUniversalMode: true,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en","messages":{"en":{"philosophy":"philosophy","projects":"projects","viewProject":"view project","services":"services","team":"team","news":"news","blog":"blog","contact":"contact","menu":"menu","all":"all","seeAll":"see all","client":"client","users":"users","location":"location","type":"type","area":"area","year":"year","budget":"budget","viewProjects":"view projects","viewBlog":"view blog","designPhilosophy":"design philosophy","meetTheTeam":{"question":"Would you like to meet the","team":"team"},"back":"back","backToProjects":"back to projects","relatedProjects":"related projects","seeMore":"see more","next":"next","backToHome":"back to home","processTimeline":"process timeline","development":"powered by onvocado"},"bg":{"philosophy":"философия","projects":"проекти","services":"услуги","team":"екип","news":"новини","blog":"блог","contact":"връзка","menu":"меню","all":"всички","seeAll":"виж всички","client":"клиент","users":"за кого е","location":"локация","type":"тип","area":"площ","year":"година","budget":"бюджет","viewProject":"виж проекта","viewProjects":"виж проектите","viewBlog":"виж блог","designPhilosophy":"дизайн философия","meetTheTeam":{"question":"Искаш ли да се запознаеш с","team":"екипа"},"back":"назад","backToProjects":"обратно към проектите","relatedProjects":"сходни проекти","seeMore":"виж повече","next":"следващ","backToHome":"към начална страница","processTimeline":"таймлайн на процеса","development":"разработено от onvocado"}}},
  vueI18nLoader: true,
  locales: [{"code":"en","iso":"en-US","name":"English"},{"code":"bg","iso":"bg-BG","name":"Bulgaria"}],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "prefix_except_default",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieAge":365,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","redirectOn":"root","useCookie":true},
  differentDomains: false,
  baseUrl: "https://www.lusio.bg",
  vuex: {"moduleName":"i18n","syncRouteParams":true},
  parsePages: false,
  pages: {"blog/_slug":{"en":"/blog/:slug","bg":"/blog/:slug"},"projects/_slug":{"en":"/project/:slug","bg":"/proekt/:slug"},"news/_slug":{"en":"/news/:slug","bg":"/novini/:slug"}},
  skipSettingLocaleOnNavigate: false,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  encodePaths: false,
  normalizedLocales: [{"code":"en","iso":"en-US","name":"English"},{"code":"bg","iso":"bg-BG","name":"Bulgaria"}],
  localeCodes: ["en","bg"],
  additionalMessages: [],
}
export const localeFiles = {
  0: "{",
  1: "}",
}

export const localeMessages = {}
